import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderDnipro(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-dnipro/create-distribution-order-dnipro",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderDnipro(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-dnipro/create-distribution-to-order-dnipro",
      params,
      callBackFn
    );
  },
  async getDniproAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-dnipro/get-dnipro-account-distribution-debt",
      params,
      callBackFn
    );
  },
  async createDistributionOrderDniproRegion(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-dnipro/create-distribution-order-dnipro-region",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderDniproRegion(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-dnipro/create-distribution-to-order-dnipro-region",
      params,
      callBackFn
    );
  },
  async getDniproRegionAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-dnipro/get-dnipro-region-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
